export enum RideStationPanelMode {
  GRID_PANEL = "GRID_PANEL",
  CRUD_TAB = "CRUD_TAB",
  DRAG_OVERLAY = "DRAG_OVERLAY",
}
